<template>
  <div class="exam-instructions">
    <div class="instructions-header">
      <h3>{{ PaperInfo.essayPapersName || '考試說明' }}</h3>
    </div>

    <div class="instructions-content">
      <div class="instruction-section notice">
        <h4><i class="fa fa-exclamation-triangle"></i> 注意事項</h4>
        <p>一、限使用Chrome瀏覽器。請先完成<a href="https://cbtpw.moex.gov.tw/PWWebOWR/file/Chrome-Browser-Setup.pdf" target="_blank" class="manual-link">Chrome瀏覽器設定</a>。</p>
        <p>二、若您對於應試介面有任何建議，歡迎<a href="/novices/contact" class="manual-link">與我們聯繫</a>。</p>
        <p>三、本系統係屬模擬性質，其介面及使用方式仍以當天實際考試為主。</p>
      </div>

      <div class="instruction-section">
        <h4><i class="fa fa-info-circle"></i> 操作說明</h4>
        <p>一、登入時，請使用滑鼠點選電腦螢幕上之鍵盤圖示或以鍵盤輸入國民身分證統一編號，按【送出】鈕。</p>
        <p>二、登入後，請仔細核對螢幕上顯示之資訊，確認無誤後，按【確定】鈕。</p>
        <p>三、申論式試題作答相關事項如下：</p>
        <p class="sub-item">(一)請逐題使用鍵盤及滑鼠輸入作答內容，由左至右橫式作答。</p>
        <p class="sub-item">(二)應試介面操作說明請參考<a href="https://cbtpw.moex.gov.tw/PWWebOWR/file/Essay-User-Guide.pdf" target="_blank" class="manual-link">申論式試題線上作答操作手冊</a>。</p>
        <p class="sub-item">(三)試題以每次一題方式顯示於螢幕畫面，依試題長度不同，可視狀況使用螢幕捲軸瀏覽試題。</p>
        <p>四、預備時間(5分鐘)：</p>
        <p class="sub-item">可進入練習畫面 (點選【進入練習】按鈕)；</p>
        <p class="sub-item">或查閱操作手冊 (點選【操作手冊】連結)；</p>
        <p class="sub-item">或瀏覽試場規則 (點選【試場規則】連結)；</p>
        <p class="sub-item">或靜候考試開始 (應試作答)。</p>
        <p>五、應試作答</p>
        <!-- <p>五、應試作答 ({{ ExamDuration }})：</p> -->
        <p class="sub-item">(一)考試賸餘時間開始倒數計時，試題同時顯示於螢幕上。</p>
        <p class="sub-item">
          (二)本系統應試作答4分鐘後將顯示【結束作答】按鈕，可提前結束作答；惟依據試場規則，正式考試時應試系統將於開始考試後45分鐘方顯示【結束作答】按鈕。
        </p>
      </div>
    </div>

    <div class="instructions-footer">
      <button @click="StartExam" class="btn btn-primary btn-lg">
        開始模擬考
      </button>
      <button @click="CancelExam" class="btn btn-secondary btn-lg ml-md-3 ml-0 mt-md-0 mt-3">
        取消考試
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExamInstructions',
  props: {
    PaperInfo: {
      type: Object,
      required: true,
    },
  },
  computed: {
    // ExamDuration() {
    //   if (!this.PaperInfo.allowedDurationSeconds) return '不限時';
    //   const totalSeconds = this.PaperInfo.allowedDurationSeconds;
    //   const hours = Math.floor(totalSeconds / 3600);
    //   const minutes = Math.floor((totalSeconds % 3600) / 60);

    //   if (hours > 0) {
    //     return minutes > 0 ? `${hours} 小時 ${minutes} 分鐘` : `${hours} 小時`;
    //   }
    //   return `${minutes} 分鐘`;
    // },
  },
  methods: {
    getFileUrl() {
      if (!this.PaperInfo.fileUrl) return '';
      // 如果是完整 URL 就直接回傳
      if (this.PaperInfo.fileUrl.startsWith('http')) {
        return this.PaperInfo.fileUrl;
      }
      // 否則加上 API 路徑
      return `${process.env.VUE_APP_APIPATH}/${this.PaperInfo.fileUrl}`;
    },
    StartExam() {
      this.$emit('start-exam');
    },
    CancelExam() {
      this.$emit('cancel-exam');
    },
  },
};
</script>

<style scoped>
.exam-instructions {
  background: #fff;
  border-radius: 8px;
  padding: 30px;
  max-width: 800px;
  margin: 0 auto;
}

.instructions-header {
  text-align: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #e9ecef;
}

.instructions-header h3 {
  font-size: 24px;
  font-weight: 600;
  color: #212529;
}

.instructions-content {
  margin-bottom: 30px;
}

.instruction-section {
  margin-bottom: 24px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 6px;
}

.instruction-section h4 {
  font-size: 16px;
  font-weight: 600;
  color: #212529;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.instruction-section p {
  line-height: 1.8;
  color: #495057;
}

.instruction-section .sub-item {
  margin-bottom: 8px;
  margin-left: 24px;
  line-height: 1.8;
  color: #495057;
}

.instruction-section.notice {
  background: #fff3cd;
  border-left: 4px solid #ffc107;
}

.manual-link {
  color: #0096a4;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.manual-link:hover {
  text-decoration: underline;
}

.instructions-footer {
  text-align: center;
}

.instructions-footer .btn {
  padding: 12px 48px;
  font-size: 16px;
  font-weight: 500;
}

@media (max-width: 768px) {
  .exam-instructions {
    padding: 20px;
  }

  .instructions-header h3 {
    font-size: 20px;
  }

  .instruction-section {
    padding: 16px;
  }

  .instructions-footer .btn {
    width: 100%;
    padding: 12px 24px;
  }
}
</style>
